<template>
  <div class="calculator-collection">
    <el-card class="header-card">
      <div class="main-title">雪音直播间计算器合集</div>
      <div class="sub-title">输入即算，实时反馈 | 礼物积分、人气票、图片识别</div>
    </el-card>

    <div class="calc-tabs">
      <div class="tab-item" :class="{ active: activeTab === 'gift' }" @click="activeTab = 'gift'">礼物积分计算器</div>
      <div class="tab-item" :class="{ active: activeTab === 'popularity' }" @click="activeTab = 'popularity'">人气票计算器
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'image' }" @click="activeTab = 'image'">图片识别导入</div>
    </div>

    <div class="calc-panel" v-if="activeTab === 'gift'">
      <el-card class="integrated-card">
        <div class="panel-section input-section">
          <div class="section-header">
            <div class="section-icon icon-gift"></div>
            <span class="section-title">礼物选择 & 数量设置</span>
          </div>
          <div class="section-content">
            <el-row :gutter="20" align="middle" class="input-row">
              <el-col :xs="24" :sm="6" :md="6">
                <div class="form-item">
                  <label class="form-label">钻石价格</label>
                  <el-input v-model="giftPrice" placeholder="输入钻石价自动匹配" type="number" min="1" size="medium"
                    style="width: 100%;" @input="handleGiftPriceInput" />
                </div>
              </el-col>
              <el-col :xs="24" :sm="8" :md="9">
                <div class="form-item">
                  <label class="form-label">礼物名称</label>
                  <el-select v-model="customGiftName" placeholder="可选择或输入礼物名" style="width: 100%;" size="medium"
                    filterable allow-create @change="handleGiftNameChange">
                    <el-option v-for="item in giftNameOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </div>
              </el-col>
              <el-col :xs="24" :sm="5" :md="4">
                <div class="form-item">
                  <label class="form-label">礼物数量</label>
                  <el-input-number v-model="giftQuantity" :min="1" :step="1" style="width: 100%;" size="medium" />
                </div>
              </el-col>
              <el-col :xs="24" :sm="5" :md="5">
                <div class="form-item">
                  <label class="form-label">操作</label>
                  <div style="display: flex; gap: 8px; width: 100%;">
                    <el-button type="primary" icon="el-icon-check" size="medium" @click="handleGiftAdd"
                      style="flex: 2;">确认添加</el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="export-all-wrap" ref="exportAll">
          <div class="panel-section pool-section">
            <div class="section-header">
              <div class="section-icon icon-list"></div>
              <span class="section-title">待计算礼物池</span>
            </div>
            <div class="section-content">
              <div v-if="calculationPool.length === 0" class="empty-tip">暂无礼物，请先选择礼物并输入数量</div>
              <el-table v-else :data="calculationPool" style="width: 100%; margin-bottom: 16px;" size="medium" border
                :header-cell-style="{ background: '#f8f9fa', fontWeight: 'bold' }">
                <el-table-column prop="name" label="礼物名称" min-width="150"></el-table-column>
                <el-table-column prop="price" label="单价(钻)" width="100" align="center"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="100" align="center"></el-table-column>
                <el-table-column prop="singlePoints" label="单礼物积分" width="120" align="center"></el-table-column>
                <el-table-column prop="totalPoints" label="单类总积分" width="120" align="center"></el-table-column>
                <el-table-column prop="totalPrice" label="单类总钻" width="120" align="center"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                  <template slot-scope="scope">
                    <el-button @click="removeFromPool(scope.row.id)" type="text" icon="el-icon-delete" size="small"
                      style="color: #f56c6c;">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-if="calculationPool.length > 0" type="warning" size="small" @click="clearPool"
                icon="el-icon-refresh-left" plain>清空计算池</el-button>
            </div>
          </div>

          <div class="panel-section result-section">
            <div class="section-header">
              <div class="section-icon icon-result"></div>
              <span class="section-title">计算结果</span>
              <div style="margin-left:auto;display:flex;gap:8px;">
                <el-button type="success" size="mini" icon="el-icon-copy-document"
                  :disabled="calculationPool.length === 0" @click="copyResult">复制</el-button>
                <el-button type="primary" size="mini" icon="el-icon-download" :disabled="calculationPool.length === 0"
                  @click="exportExcel">导出Excel</el-button>
                <el-button type="info" size="mini" icon="el-icon-camera" :disabled="calculationPool.length === 0"
                  @click="exportImage">截图</el-button>
              </div>
            </div>
            <div class="section-content">
              <div class="result-grid">
                <div class="result-item">
                  <span class="result-label">总钻石数</span>
                  <span class="result-value">{{ totalDiamonds }} 钻</span>
                </div>
                <div class="result-item">
                  <span class="result-label">总积分</span>
                  <span class="result-value points">{{ totalPoints }}</span>
                </div>
                <div class="result-item">
                  <span class="result-label">总溢出</span>
                  <span class="result-value overflow">{{ totalOverflow }} 钻</span>
                </div>
              </div>
              <div class="rule-card">计算规则：单礼物积分=钻石价格÷599向下取整 | 总溢出=总钻石-总积分×599</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>

    <div class="calc-panel" v-if="activeTab === 'popularity'">
      <el-card class="integrated-card">
        <div class="two-column-layout">
          <div class="left-column">
            <div class="panel-section input-section">
              <div class="section-header">
                <div class="section-icon icon-rank"></div>
                <span class="section-title">人气票基础配置</span>
              </div>
              <div class="section-content compact-content">
                <el-row :gutter="16" class="input-row mode-row">
                  <el-col :xs="24">
                    <div class="form-item inline-form-item">
                      <label class="form-label inline-label">计算模式：</label>
                      <el-radio-group v-model="popularityMode" size="medium" class="inline-radio-group">
                        <el-radio label="count2value" border class="inline-radio">算张数→人气值</el-radio>
                        <el-radio label="value2count" border class="inline-radio">算人气值→张数</el-radio>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="16" class="input-row">
                  <el-col :xs="24" :sm="12" :md="8">
                    <div class="form-item">
                      <label class="form-label">粉丝团等级</label>
                      <el-select v-model="selectedLevel" placeholder="请选择等级" style="width: 100%;" size="medium">
                        <el-option label="非粉丝团" value="0"></el-option>
                        <el-option label="1-2级" value="1"></el-option>
                        <el-option label="3-5级" value="2"></el-option>
                        <el-option label="6-10级" value="3"></el-option>
                        <el-option label="11-20级" value="4"></el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="16">
                    <div class="form-item">
                      <label class="form-label">是否星守护</label>
                      <el-switch v-model="isStarGuardian" active-text="是" inactive-text="否"
                        class="inline-switch"></el-switch>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="16" class="input-row" style="margin-top: 16px;">
                  <el-col :xs="24" v-if="popularityMode === 'count2value'">
                    <div class="form-item">
                      <label class="form-label">人气票张数</label>
                      <el-input-number v-model="popularityCount" :min="1" :step="1" style="width: 100%;" size="medium"
                        @change="calcPopularityRealTime"></el-input-number>
                      <div v-if="popularityCount > 600" class="warn-tip" style="pointer-events: none;">⚠️
                        每小时上限600张，超量不计入人气值
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" v-if="popularityMode === 'value2count'">
                    <div class="form-item">
                      <label class="form-label">目标人气值</label>
                      <el-input-number v-model="targetPopularityValue" :min="1" :step="1" style="width: 100%;"
                        size="medium"></el-input-number>
                    </div>
                  </el-col>
                </el-row>
                <div class="calc-btn-wrapper">
                  <el-button type="primary" size="medium" icon="el-icon-check" @click="calcPopularityRealTime"
                    class="confirm-btn">确认计算</el-button>
                  <div class="tips-text">💡 调整配置后，点击“确认计算”更新结果</div>
                </div>
              </div>
            </div>
            <div class="panel-section result-section">
              <div class="section-header">
                <div class="section-icon icon-result"></div>
                <span class="section-title">计算结果</span>
              </div>
              <div class="section-content">
                <div v-if="!hasCalculated" class="empty-tip">请先配置参数并点击“确认计算”</div>
                <div v-else-if="!selectedLevel" class="empty-tip">请先选择粉丝团等级</div>
                <div v-else class="result-grid">
                  <div class="result-item" v-if="popularityMode === 'count2value'">
                    <span class="result-label">实际贡献人气值</span>
                    <span class="result-value points">{{ totalPopularityValue }}</span>
                    <span v-if="popularityCount > 600" class="sub-tip">（按600张上限计算）</span>
                  </div>
                  <div class="result-item" v-if="popularityMode === 'value2count'">
                    <span class="result-label">所需人气票张数</span>
                    <span class="result-value points">{{ neededPopularityCount }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">单张人气票值</span>
                    <span class="result-value">{{ singlePopularityValue }}</span>
                  </div>
                </div>
                <div class="rule-card">计算规则：人气值=单张值×有效张数+首张奖励 | 星守护享1.5倍加成</div>
              </div>
            </div>
          </div>
          <div class="right-column">
            <div class="rule-table-card">
              <div class="section-header">
                <div class="section-icon icon-rank"></div>
                <span class="section-title">人气票等级规则表</span>
              </div>
              <el-table :data="transposedRuleTableData" border size="small" style="width:100%; flex:1;"
                :header-cell-style="{ background: '#f8f9fa', fontWeight: 'bold', height: '44px' }"
                :cell-style="{ textAlign: 'center', height: '54px' }">
                <el-table-column label="团等级" prop="grade" width="110"
                  :cell-style="{ background: '#f0f7ff', textAlign: 'left', paddingLeft: '12px' }" />
                <el-table-column label="单张值" prop="singleValue" />
                <el-table-column label="首张奖励" prop="firstReward" />
                <el-table-column label="个数上限/时" prop="countLimit" />
              </el-table>
              <div class="rule-note">
                <div style="font-weight:500; margin-bottom:6px;">💡 使用须知</div>
                <div>• 每小时最多投放 600 张人气票</div>
                <div>• 粉丝等级越高，单张人气值越高</div>
                <div>• 星守护可获得 1.5 倍人气值加成</div>
                <div>• 人气值达到上限后不再增加</div>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="calc-panel" v-if="activeTab === 'image'">
      <el-card class="integrated-card">
      </el-card>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import giftData from '../assets/data/giftData.js'

export default {
  name: 'CalculatorCollection',
  components: {
  },
  data() {
    return {
      activeTab: 'gift',
      fullGiftList: giftData,
      giftQuantity: 1,
      calculationPool: [],
      totalDiamonds: 0,
      totalPoints: 0,
      totalOverflow: 0,
      poolItemId: 100,
      giftPrice: '',
      customGiftName: '',
      giftNameOptions: [],
      customGiftIndex: 1,

      popularityMode: 'count2value',
      selectedLevel: '',
      popularityCount: 1,
      isStarGuardian: false,
      targetPopularityValue: 0,
      totalPopularityValue: 0,
      neededPopularityCount: 0,
      singlePopularityValue: 0,
      firstRewardValue: 200,
      hasCalculated: false,
      levelConfig: [
        { level: '0', singleValue: 4, hourlyLimit: 2600 },
        { level: '1', singleValue: 5, hourlyLimit: 3200 },
        { level: '2', singleValue: 6, hourlyLimit: 3800 },
        { level: '3', singleValue: 7, hourlyLimit: 4400 },
        { level: '4', singleValue: 8, hourlyLimit: 5000 },
      ],
      transposedRuleTableData: [
        { grade: '非粉丝团', singleValue: 4, firstReward: 200, countLimit: 600, valueLimit: 2600 },
        { grade: '1-2级', singleValue: 5, firstReward: 200, countLimit: 600, valueLimit: 3200 },
        { grade: '3-5级', singleValue: 6, firstReward: 200, countLimit: 600, valueLimit: 3800 },
        { grade: '6-10级', singleValue: 7, firstReward: 200, countLimit: 600, valueLimit: 4400 },
        { grade: '11-20级', singleValue: 8, firstReward: 200, countLimit: 600, valueLimit: 5000 },
      ]
    }
  },
  mounted() {
    this.giftNameOptions = this.fullGiftList.map(g => ({ label: g.name, value: g.name }))
  },
  methods: {
    handleAddRow(row) {
      const idx = this.calculationPool.findIndex(item => item.name === row.giftName && item.price === row.price);
      if (idx > -1) {
        this.calculationPool[idx].quantity += row.count;
        this.calculationPool[idx].totalPoints = Math.floor(row.price / 599) * this.calculationPool[idx].quantity;
        this.calculationPool[idx].totalPrice = row.price * this.calculationPool[idx].quantity;
      } else {
        this.calculationPool.push({
          id: this.poolItemId++,
          name: row.giftName,
          price: row.price,
          quantity: row.count,
          singlePoints: Math.floor(row.price / 599),
          totalPoints: row.points,
          totalPrice: row.price * row.count
        });
      }
      this.calcGiftResultRealTime();
      this.$message.success(`已将【${row.giftName}】加入计算池`);
    },

    handleGiftPriceInput() {
      const val = this.giftPrice?.trim()
      if (!val) {
        this.giftNameOptions = this.fullGiftList.map(g => ({ label: g.name, value: g.name }))
        this.customGiftName = ''
        return
      }
      const price = Number(val)
      if (isNaN(price)) return
      const matched = this.fullGiftList.filter(g => g.price === price)
      this.giftNameOptions = matched.map(g => ({ label: g.name, value: g.name }))
      if (matched.length > 0) this.customGiftName = matched[0].name
      else this.customGiftName = `自定义礼物${this.customGiftIndex}`
    },
    handleGiftNameChange(name) {
      if (!name) return
      const gift = this.fullGiftList.find(g => g.name === name)
      if (gift) this.giftPrice = String(gift.price)
    },
    handleGiftAdd() {
      const price = Number(this.giftPrice)
      const quantity = this.giftQuantity
      if (!price || price < 1 || !quantity || quantity < 1) {
        this.$message.warning('请输入有效的钻石价格和数量')
        return
      }
      let finalName = this.customGiftName || `自定义礼物${this.customGiftIndex}`
      let finalPrice = price
      const singlePoints = Math.floor(finalPrice / 599)
      const totalPoints = singlePoints * quantity
      const totalPrice = finalPrice * quantity
      const idx = this.calculationPool.findIndex(x => x.name === finalName && x.price === finalPrice)
      if (idx > -1) {
        this.calculationPool[idx].quantity = quantity
        this.calculationPool[idx].totalPoints = totalPoints
        this.calculationPool[idx].totalPrice = totalPrice
      } else {
        this.calculationPool.push({ id: this.poolItemId++, name: finalName, price: finalPrice, quantity, singlePoints, totalPoints, totalPrice })
        this.customGiftIndex++
      }
      this.calcGiftResultRealTime()
      this.giftPrice = ''
      this.giftQuantity = 1
      this.customGiftName = ''
    },
    calcGiftResultRealTime() {
      this.totalDiamonds = 0
      this.totalPoints = 0
      this.calculationPool.forEach(item => {
        this.totalDiamonds += item.totalPrice
        this.totalPoints += item.totalPoints
      })
      this.totalOverflow = Math.max(this.totalDiamonds - this.totalPoints * 599, 0)
    },
    removeFromPool(id) {
      const idx = this.calculationPool.findIndex(item => id === item.id)
      if (idx > -1) {
        this.calculationPool.splice(idx, 1)
        this.calcGiftResultRealTime()
      }
    },
    clearPool() {
      this.calculationPool = []
      this.calcGiftResultRealTime()
    },
    copyResult() {
      let t = "礼物名称\t单价(钻)\t数量\t单积分\t小计积分\t小计钻石\n";
      this.calculationPool.forEach(i => t += `${i.name}\t${i.price}\t${i.quantity}\t${i.singlePoints}\t${i.totalPoints}\t${i.totalPrice}\n`)
      t += `\n总积分：${this.totalPoints}\n总钻石：${this.totalDiamonds}`;
      navigator.clipboard.writeText(t).then(() => this.$message.success("复制成功"));
    },
    exportExcel() {
      let csv = "\ufeff礼物名称,单价(钻),数量,单礼物积分,小计积分,小计钻石\n";
      this.calculationPool.forEach(item => csv += `${item.name},${item.price},${item.quantity},${item.singlePoints},${item.totalPoints},${item.totalPrice}\n`)
      csv += `\n总计,,,,${this.totalPoints},${this.totalDiamonds}\n`;
      const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = "礼物结算单.csv";
      a.click();
      URL.revokeObjectURL(url);
      this.$message.success("导出成功！总计行已修复，无错位");
    },
    exportImage() {
      html2canvas(this.$refs.exportAll, { backgroundColor: "#ffffff", useCORS: true, scale: 2 }).then(canvas => {
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = "礼物结算截图.png";
        a.click();
        this.$message.success("截图保存成功");
      });
    },

    calcPopularityRealTime() {
      this.hasCalculated = true
      if (!this.selectedLevel) {
        this.singlePopularityValue = 0
        this.totalPopularityValue = 0
        this.neededPopularityCount = 0
        return
      }
      const levelConf = this.levelConfig.find(item => item.level === this.selectedLevel)
      if (!levelConf) return
      this.singlePopularityValue = levelConf.singleValue
      this.firstRewardValue = 200
      const effectiveCount = Math.min(this.popularityCount, 600)
      if (this.popularityMode === 'count2value') {
        let total = this.singlePopularityValue * effectiveCount + this.firstRewardValue
        if (this.isStarGuardian) {
          total = Math.floor(total * 1.5)
          total = Math.min(total, levelConf.hourlyLimit + 2500)
        } else {
          total = Math.min(total, levelConf.hourlyLimit)
        }
        this.totalPopularityValue = total
      } else {
        if (!this.targetPopularityValue || this.targetPopularityValue <= 0) {
          this.neededPopularityCount = 0
          return
        }
        let target = this.targetPopularityValue - this.firstRewardValue
        if (this.isStarGuardian) target = Math.ceil(target / 1.5)
        target = Math.max(target, 0)
        this.neededPopularityCount = Math.max(Math.ceil(target / this.singlePopularityValue), 1)
      }
    }
  }
}
</script>

<style scoped>
:root {
  --container-max-width: 1000px;
}

.calculator-collection,
.header-card,
.calc-tabs,
.calc-panel,
.integrated-card {
  box-sizing: border-box;
}

.calculator-collection {
  padding: 16px 24px;
  max-width: var(--container-max-width);
  margin: 0 auto;
  background-color: #E3E8F4;
  min-height: 100vh;
}

.header-card {
  text-align: center;
  margin-bottom: 30px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 50%);
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.main-title {
  font-size: 28px;
  color: #ffad32;
  margin-bottom: 10px;
  letter-spacing: 2px;
  font-weight: bold;
}

.sub-title {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.calc-tabs {
  display: flex;
  margin-bottom: 16px;
  background: #fff;
  border-radius: 8px;
  padding: 4px;
  max-width: var(--container-max-width);
  width: 100%;
  margin: 0 auto 16px auto;
}

.tab-item {
  flex: 1;
  padding: 12px 6px;
  cursor: pointer;
  font-size: 15px;
  color: #6b7280;
  text-align: center;
  border-radius: 6px;
  transition: all 0.2s;
  font-weight: 500;
}

.tab-item.active {
  color: #fff;
  background: #409eff;
}

.tab-item:hover:not(.active) {
  color: #409eff;
  background: #f0f7ff;
}

.calc-panel {
  width: 100%;
  max-width: var(--container-max-width);
  margin: 0 auto;
}

.integrated-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
}

.two-column-layout {
  display: flex;
  gap: 20px;
  padding: 16px 20px;
  align-items: stretch;
}

.left-column {
  flex: 1.1;
  min-width: 420px;
}

.right-column {
  flex: 1;
  min-width: 380px;
}

.panel-section {
  padding: 16px 20px;
  border-bottom: 1px solid #f3f4f6;
}

.panel-section:last-child {
  border-bottom: none
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

.icon-gift {
  background: #409eff;
}

.icon-list {
  background: #67c23a;
}

.icon-result {
  background: #1989fa;
}

.icon-rank {
  background: #f7ba1e;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.input-row {
  margin-bottom: 12px;
}

.mode-row {
  margin-bottom: 18px;
}

.form-item {
  width: 100%;
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 15px;
  color: #374151;
  margin-bottom: 8px;
  font-weight: 500;
}

.inline-form-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.inline-label {
  margin-right: 14px;
  white-space: nowrap;
  margin-bottom: 0;
}

.inline-radio-group {
  display: flex;
  gap: 12px;
  flex: 1;
}

.inline-radio {
  flex: 1;
  border-radius: 6px;
}

.inline-switch {
  margin-top: 4px;
}

.calc-btn-wrapper {
  margin-top: 20px;
  text-align: center;
}

.confirm-btn {
  padding: 10px 28px !important;
}

.tips-text {
  margin-top: 8px;
  font-size: 13px;
  color: #666;
}

.warn-tip {
  margin-top: 6px;
  font-size: 13px;
  color: #f56c6c;
}

.empty-tip {
  text-align: center;
  padding: 30px 0;
  color: #999;
  font-size: 14px;
}

.result-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
}

.result-item {
  padding: 16px;
  background: #f7f8fa;
  border-radius: 8px;
  text-align: center;
}

.result-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
}

.result-value {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.result-value.points {
  color: #409eff;
}

.result-value.overflow {
  color: #f56c6c;
}

.sub-tip {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.rule-card {
  margin-top: 14px;
  padding: 10px 14px;
  background: #f0f7ff;
  border-radius: 6px;
  font-size: 13px;
  color: #409eff;
}

.rule-table-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  background: #f7f8fa;
  border-radius: 8px;
}

.rule-note {
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.7;
  color: #555;
}

.upload-inner-wrap {
  padding: 4px;
}

.upload-btn-bar {
  margin-top: 16px;
}
</style>